import { useEffect, useState } from "react";
import { Asset } from "../../../../../models/asset";
import { getAssetByChassis } from "../../../../../utils/assetUtils";
import useAssets from "../../../../../hooks/useAssets";
import { fetchMaintenance } from "../../../../../api/fetchMaintenance";

export const useOccurrenceVehicleSummaryCard = (chassis: string) => {
    const { allAssets } = useAssets();

    const [customMaintenanceGroupLoading, setCustomMaintenanceGroupLoading] = useState(false);
    const [customMaintenanceGroup, setCustomMaintenanceGroup] = useState<string | null>(null);
    const [customMaintenanceGroupSaved, setCustomMaintenanceGroupSaved] = useState(false);

    // Vehicle data
    const [maintenanceGroup, setMaintenanceGroup] = useState<string>();

    const fetchAssetData = async (asset: Asset) => {
        const [assets, _] = await fetchMaintenance([{ id: asset.id, identification: asset.chassis, name: asset.name }]);
        const assetFound = assets.length > 0 ? assets[0] : null;
        console.log('assetFound', assetFound);
        if (assetFound && (assetFound.groupName !== '-')) setMaintenanceGroup(assetFound.group);
        else setMaintenanceGroup(undefined);
    }

    useEffect(() => {
        const asset = getAssetByChassis(allAssets, chassis);
        if(asset) fetchAssetData(asset);
    }, [chassis]);

    return {
        maintenanceGroup,
        customMaintenanceGroup,
        customMaintenanceGroupLoading,
        customMaintenanceGroupSaved,
        setCustomMaintenanceGroup,
        setCustomMaintenanceGroupLoading,
        setCustomMaintenanceGroupSaved,
    }
}